export default __webpack_public_path__ + "static/media/achievement-4.3a1b4bfb.jpg";